import { render, staticRenderFns } from "./liveClassFestivalReview.vue?vue&type=template&id=4d43cdb0"
import script from "./liveClassFestivalReview.vue?vue&type=script&lang=js"
export * from "./liveClassFestivalReview.vue?vue&type=script&lang=js"
import style0 from "./liveClassFestivalReview.vue?vue&type=style&index=0&id=4d43cdb0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports